var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoViolationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4963 2.42942C9.32502 0.984517 10.8634 0.0933838 12.5291 0.0933838C14.1948 0.0933838 15.7332 0.984517 16.5619 2.42942L24.5191 16.3029C24.8724 16.9188 25.0582 17.6164 25.0582 18.3264C25.0582 20.5725 23.2373 22.3934 20.9913 22.3934H4.06705C1.82088 22.3934 0 20.5725 0 18.3264C0 17.6164 0.185869 16.9188 0.539086 16.3029L8.4963 2.42942ZM12.5291 2.18157C11.6116 2.18157 10.7642 2.67244 10.3077 3.46833L2.35048 17.3419C2.17862 17.6415 2.08819 17.9809 2.08819 18.3264C2.08819 19.4194 2.97416 20.3052 4.06705 20.3052H20.9913C22.084 20.3052 22.97 19.4194 22.97 18.3264C22.97 17.9809 22.8796 17.6415 22.7078 17.3419L14.7505 3.46833C14.294 2.67244 13.4466 2.18157 12.5291 2.18157Z",
    fill: "#F87E3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5291 6.32668C13.1058 6.32668 13.5732 6.79414 13.5732 7.37077V12.8452C13.5732 13.4218 13.1058 13.8893 12.5291 13.8893C11.9525 13.8893 11.485 13.4218 11.485 12.8452V7.37077C11.485 6.79414 11.9525 6.32668 12.5291 6.32668ZM12.5291 15.9446C13.1058 15.9446 13.5732 16.4121 13.5732 16.9887V17.4848C13.5732 18.0614 13.1058 18.5289 12.5291 18.5289C11.9525 18.5289 11.485 18.0614 11.485 17.4848V16.9887C11.485 16.4121 11.9525 15.9446 12.5291 15.9446Z",
    fill: "#F87E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoViolationsIcon);
export default __webpack_public_path__ + "static/media/info-violationsIcon.75c21868dc8e649e08d3fd54c17b8f4d.svg";
export { ForwardRef as ReactComponent };